import { Skeleton, Stack } from '@mui/material'
import { useProjectGridFieldsContext } from '../validation/ProjectGridFieldsProvider'
import useFieldValue from '../validation/useFieldValue'
import {
  INVOICE_VENDOR_INFO_TYPE_ID,
  RECEIPT_VENDOR_INFO_TYPE_ID,
} from '../validation/VisibleCardsControl'
import LiveListPickerField from '../validation/fields/LiveListPickerField'
import { LiveListEntity } from '@/types/live-lists'
import { ProjectGridField } from '@/types/fields'
import QBOVendorDetails from './QBOVendorDetails'

export default function VendorCard() {
  const fields = useProjectGridFieldsContext()

  // We don't render this component unless there is a vendor field,
  // so we don't need to check that here.
  const vendorField = fields.find(
    (field) =>
      field.info_type_id === INVOICE_VENDOR_INFO_TYPE_ID ||
      field.info_type_id === RECEIPT_VENDOR_INFO_TYPE_ID,
  ) as ProjectGridField

  const { jsonValue, onManualChange } = useFieldValue({
    field: vendorField,
  })

  return vendorField ? (
    <Stack spacing={2}>
      <LiveListPickerField
        value={jsonValue as LiveListEntity}
        field={vendorField}
        onChange={onManualChange}
        label="Vendor"
        slotProps={{
          inputLabel: {
            shrink: true,
          },
        }}
      />
      {jsonValue && (
        <QBOVendorDetails entityJson={jsonValue as LiveListEntity} />
      )}
    </Stack>
  ) : (
    <>
      <Skeleton width="100%" />
      <Skeleton width="75%" />
    </>
  )
}
